// extracted by mini-css-extract-plugin
export var chip = "_qs-0";
export var icon = "_qs-1";
export var remove = "_qs-2";
export var removeIcon = "_qs-3";